import {
    BotApiControllerApi,
    Configuration,
    FeedbackApiControllerApi,
    FetchAPI,
    HTTPHeaders,
    IntegrationControllerApi,
    LocationApiControllerApi,
    OfferApiControllerApi,
    TranscriptApiControllerApi,
    ValuationRuleConfigControllerApi,
    VehicleReimportControllerApi,
    WidgetAppearanceSettingsApiControllerApi
} from "./generated";
import {BACKEND_URL} from "../configs";

import {Clerk} from "@clerk/clerk-js";

export enum RequestStatus {
    NONE,
    PENDING,
    RESOLVED,
    REJECTED
}

const clerk = new Clerk("pk_test_dGhvcm91Z2gtb2NlbG90LTUzLmNsZXJrLmFjY291bnRzLmRldiQ");

const isBinaryBody = (body: BodyInit | null | undefined): boolean =>
    body instanceof Blob || body instanceof FormData || body instanceof ArrayBuffer || ArrayBuffer.isView(body);

export const globalFetchConfig: FetchAPI = async (originalReqUrl: Request | string,
                                                  originalReqParams: RequestInit | undefined) => {
    await clerk.load({})
    const token = await clerk.session?.getToken()

    const headers = new Headers(originalReqParams?.headers || {});
    // Most calls send JSON, but the assistant configuration import uploads a ZIP and the export
    // downloads one. Only default the content type when the caller has not chosen one and the
    // body is not a binary payload the browser needs to describe itself.
    if (!headers.has("Content-Type") && !isBinaryBody(originalReqParams?.body)) {
        headers.set("Content-Type", "application/json");
    }
    if (token) {
        headers.set("Authorization", `Bearer ${token}`);
    }

    return fetch(originalReqUrl, {
        ...originalReqParams,
        headers,
    });
}


export const createDefaultHeaders = (): HTTPHeaders => {
    const headers: HTTPHeaders = {};
    headers['Content-Type'] = 'application/json';
    return headers;
}

const ApiClientConfig = new Configuration(
    {
        basePath: BACKEND_URL,
        fetchApi: globalFetchConfig,
        headers: createDefaultHeaders()
    }
)

export const botApi = new BotApiControllerApi(ApiClientConfig);
export const offerApi = new OfferApiControllerApi(ApiClientConfig);
export const locationApi = new LocationApiControllerApi(ApiClientConfig);
export const integrationApi = new IntegrationControllerApi(ApiClientConfig);
export const transcriptApi = new TranscriptApiControllerApi(ApiClientConfig);
export const feedbackApi = new FeedbackApiControllerApi(ApiClientConfig);
export const vehicleReimportApi = new VehicleReimportControllerApi(ApiClientConfig);
export const widgetAppearanceApi = new WidgetAppearanceSettingsApiControllerApi(ApiClientConfig);
export const ValuationRulesConfigApi = new ValuationRuleConfigControllerApi(ApiClientConfig)
